import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const UsersIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.500"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    {...props}
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMin meet"
    fill="none"
  >
    <Path
      d="M18.3729 16.9457C19.2447 17.0884 20.046 17.4414 20.6757 17.9603C21.1171 18.306 22 19.3166 22 20.5931C22 20.7342 21.9323 20.8695 21.8117 20.9692C21.6912 21.069 21.5276 21.125 21.3571 21.125H13.6429C13.4724 21.125 13.3088 21.069 13.1883 20.9692C13.0677 20.8695 13 20.7342 13 20.5931C13.0012 19.8578 13.2655 19.1392 13.7597 18.5281C14.2538 17.9169 14.9557 17.4404 15.7766 17.1588C16.5976 16.8772 17.501 16.8031 18.3729 16.9457Z"
      fill={color}
    />
    <Path
      d="M17.5 15.875C17.9945 15.875 18.4778 15.7284 18.8889 15.4537C19.3 15.179 19.6205 14.7885 19.8097 14.3317C19.9989 13.8749 20.0484 13.3722 19.952 12.8873C19.8555 12.4023 19.6174 11.9569 19.2678 11.6072C18.9181 11.2576 18.4727 11.0195 17.9877 10.923C17.5028 10.8266 17.0001 10.8761 16.5433 11.0653C16.0865 11.2545 15.696 11.575 15.4213 11.9861C15.1466 12.3972 15 12.8805 15 13.375C15 14.038 15.2634 14.6739 15.7322 15.1428C16.2011 15.6116 16.837 15.875 17.5 15.875Z"
      fill={color}
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.94 14.9155C12.9605 13.9399 11.7141 13.2761 10.3578 13.008C9.00159 12.7398 7.59632 12.8792 6.31923 13.4087C5.04213 13.9381 3.95041 14.8339 3.18174 15.983C2.41307 17.1321 2.00187 18.483 2 19.8655C2 20.1308 2.10536 20.3851 2.29289 20.5726C2.48043 20.7602 2.73478 20.8655 3 20.8655H12.007C12.0572 19.9182 12.3748 18.9998 12.9285 18.2087C13.4646 17.4429 14.2007 16.8269 15.0611 16.4201C14.6708 15.7218 14.2399 15.1994 13.94 14.9155Z"
      fill={color}
    />
    <Path
      d="M9 10.875C9.79113 10.875 10.5645 10.6404 11.2223 10.2009C11.8801 9.76135 12.3928 9.13664 12.6955 8.40574C12.9983 7.67483 13.0775 6.87056 12.9231 6.09464C12.7688 5.31872 12.3878 4.60598 11.8284 4.04657C11.269 3.48716 10.5563 3.1062 9.78036 2.95186C9.00444 2.79752 8.20017 2.87673 7.46927 3.17948C6.73836 3.48223 6.11365 3.99492 5.67412 4.65272C5.2346 5.31052 5 6.08388 5 6.875C5 7.93587 5.42143 8.95328 6.17157 9.70343C6.92172 10.4536 7.93913 10.875 9 10.875Z"
      fill={color}
    />
  </Svg>
);

export default UsersIcon;
